import NavLayout from '../layouts/navLayout'
import SimpleLayout from '../layouts/simpleLayout'
import { OneSignalSetup } from '../utils/OneSignalSetup';
import { isValid, cookieManager } from "../utils/utilitiesmodule";

export default {
    name: 'App',
    metaInfo: {
        titleTemplate: '%s | Iperius ONE',
        htmlAttrs: {},
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Iperius ONE - the complete RMM tool for Iperius Suite.' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'nav-layout': NavLayout,
        'simple-layout': SimpleLayout,
    },
    data() {
        return {
            lang: null,
            theme: null,
            rootConnection: null,
        };
    },
    computed: {
        layout() {
            return this.$store.getters.layout;
        },
        userLogged() {
            if(!this.$root.checkAuth()){
                return null;
            }
            return `${this.$root.authObj.firstname} ${this.$root.authObj.lastname} (${this.$root.authObj.username})`;
        },
        roles() {
            return this.$store.getters.roles;
        },
        ViewComponent() {
            return this.$route.name;
        }
    },
    created() {
        const locale = localStorage.getItem('lang') || "gb";
        document.documentElement.lang = locale;
        window.METRO_LOCALE = locale;
        this.$i18n.locale = locale;
        this.$moment.locale(locale);
        this.$store.commit('SET_LAYOUT', 'nav-layout');
        console.log("CREATED APP");
    },
    watch: {
        '$route': {
            handler(to) {
                if (to.name === 'accounts') {
                    Metro.getPlugin('#backupmenu', 'dropdown').open();
                }
            },
            deep: true,
            immediate: true
        },
        $route(to) {
            if (Metro.getPlugin('#userdropdown', 'dropdown')) Metro.getPlugin('#userdropdown', 'dropdown').close();
            if (Metro.getPlugin('#langdropdown', 'dropdown')) Metro.getPlugin('#langdropdown', 'dropdown').close();

            this.checkIfIsRedirectUri();

            if (!to.fullPath.includes("#")) {
                this.$root.$emit("CLOSEALLDIALOGS");
            }
        }
    },
    async mounted() {
        await this.$root.getApiDataAndSetSession();

        const isAuth = this.$root.checkAuth();
        const isLoginPage = ['/', '/login', '/login2FA'].includes(this.$route.path);

        this.$store.commit('SET_LAYOUT', isAuth ? 'nav-layout' : 'simple-layout');

        if (!isAuth && !isLoginPage) {
            this.$router.replace('/');
        }


        if (isAuth && isLoginPage && !this.$root.authObj?.licenceExpired) {
            // qui in questo punto controlla se ho solo la licenza di iperius remote e al posto della dashboard di one mostra
            // la sola deshboard di remote con i grafici
            if (this.checkisOnlyRemoteLicensingState()) {
                this.$router.replace('/remotestats');
            }else{
                this.$router.replace('/dashboard');
            }
        }

        if (isAuth && !this.$session.exists()) {
            this.$session.start();
            this.$store.commit('SET_CLOUDS', this.cloud_types);
        }
    },
    methods: {

        checkisOnlyRemoteLicensingState() {
            const { backup, monitoring, remote } = this.$session.getLicenses();
            return remote.length > 0 && backup.length === 0 && monitoring.length === 0;
        },
        toggleTheme() {
            this.theme = this.theme === 'darkMode' ? '' : 'darkMode';
            document.documentElement.setAttribute('data-theme', this.theme);
            localStorage.setItem('theme', this.theme);
        },
        async logout() {
            this.$root.closeConnectionTimerLight();

            OneSignalSetup.logout();
            
            this.$session.remove("AUTH");
            this.$session.destroy();
            sessionStorage.clear();
            localStorage.removeItem("AUTH");
            this.$root.authObj = null;

            //this.$router.push('/')


            /*OK MA RIMANE LA CRONOLOGIA
            this.$router.push("/");
            location.reload();
            */
           this.$router.replace({ path: "/" }).catch((err) => {
                if (err.name !== 'NavigationDuplicated') {
                    console.writeError(err);
                }
            }); /**/
        },
        setLayout(layout) {
            this.$store.commit('SET_LAYOUT', layout);
        },
        checkIfIsRedirectUri() {
            const query = this.$route.query;

            if (!isValid(query)) return;

            if (isValid(query.code)) {
                cookieManager.setCookie("authCode", query.code);
                close();
            }

            const expectedConsentState = localStorage.getItem("admin_consent_state");
            const isAdminConsentRedirect = isValid(expectedConsentState) && query.state === expectedConsentState;
            if (isAdminConsentRedirect && (isValid(query.admin_consent) || isValid(query.error))) {
                cookieManager.setCookie("admin_consent", query.admin_consent === "True");
                localStorage.removeItem("admin_consent_state");
                close();
            }
        }
    }
}
